import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {connect} from "react-redux";
import {Col, Form, FormFeedback, Input, InputGroup, InputGroupAddon, InputGroupText, Row} from "reactstrap";
import InputMask from "react-input-mask";
import {first, isNull, omit} from "lodash";
import apiUser from "../../../apiUser";
import Select from "react-select";
import {toast} from "react-toastify";
import vehicleEngineType from "../../../utils/vehicleEngineType";
import Button from "../../Button";
import classnames from "classnames";
import ClientSelect from "../../Client/ClientSelect";
import Tooltip from "components/Tooltip";
import moment from "moment";
import SelectVehicleEnginePowerUnit from "../../Application/SelectVehicleEnginePowerUnit";
import AppDatePicker from "../../../componentsReusable/AppDatePicker";
import InputAutocomplete from "../../../componentsReusable/InputAutocomplete";
import apiPlatform from "../../../apiPlatform";
import {debounceTime, distinctUntilChanged, Subject} from "rxjs";
import workshopSettingsIsEnabled from "../../../utils/workshopSettingsIsEnabled";
import InputAztec from "../../InputAztec";
import getWorkshopSetting from "../../../utils/getWorkshopSetting";
import CarTypeSelect from "../../CarTypeSelect";
import AppFormCancelButton from "../../../componentsReusable/AppFormCancelButton";
import {fetchClient} from "../../../utils/fetchClient";
import ClientLabel from "../../Client/ClientLabel";
import VehicleDamagePatternImageTypeChoose from "../VehicleDamagePatternImageTypeChoose";
import Icon from "../../../componentsReusable/Icon";
import {vehicleDamagesTypesByCarType} from "../../../utils/Vehicle/vehicleDamagesTypesByCarType";
import MergeVehicles from "./MergeVehicles";
import {withTranslation} from "react-i18next";
import VehicleRegistrationNumberInput from "../VehicleRegistrationNumberInput";
import VehicleVinInput from "../VehicleVinInput";
import SelectMileageUnit from "../../Application/SelectMileageUnit";

class VehicleForm extends PureComponent {
  constructor(props) {
    super(props);

    this.onChangeBrandData$ = new Subject();
    this.onChangeModelData$ = new Subject();

    const data = {
      ...this.getOmittedData(props.data),
      ...props.dataInitial,
    }

    if(!data?.carType){
      data.carType = {
        id: first(getWorkshopSetting('vehicle.carTypes')),
      }
    }

    if(!data.damagePatternImageType){
      data.damagePatternImageType = first(vehicleDamagesTypesByCarType(data?.carType?.id))
    }

    this.state = {
      objChanges: {},
      errors: {},
      saving: false,
      data,
    };

    this.getOmittedData = this.getOmittedData.bind(this);
    this.onChangeData = this.onChangeData.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    this.onChangeBrandData$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
    ).subscribe((data) => {
      this.setState({
        data: {
          ...this.state.data,
          ...data,
        }
      })
    });
    this.onChangeModelData$.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
    ).subscribe((data) => {
      this.setState({
        data: {
          ...this.state.data,
          ...data,
        }
      })
    });
  }

  getOmittedData(data){
    return {
      ...omit(data, ['id', 'createdAt', 'updatedAt', 'files'])
    }
  }

  onChangeData(obj){
    const state = {
      data: {
        ...this.state.data,
        ...obj,
      }
    }

    this.setState(state)
  }

  onSubmit(e){
    const {data} = this.state;

    this.setState({
      saving: true,
      errors: {},
    });

    if(this.props.onSavingStart){
      this.props.onSavingStart();
    }

    if(isNull(this.props.data.id)){
      apiUser.vehicles.post(data)
        .then(data => {
          this.setState({
            saving: false,
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }

          this.props.onCreated(data);

          toast.success(this.props.t('created'));
        })
        .catch(res => {
          this.setState({
            saving: false,
            errors: res?.response?.data?.children ?? {}
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }
        });
    }else{
      apiUser.vehicles.patch(this.props.data.id, data)
        .then(data => {
          this.setState({
            saving: false,
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }

          toast.success(this.props.t('common:data_has_been_saved'));
        })
        .catch(res => {
          this.setState({
            saving: false,
            errors: res?.response?.data?.children ?? {}
          });

          if(this.props.onSavingStop){
            this.props.onSavingStop();
          }
        });
    }
  }

  handleDecodedData = (data) => {
    this.setState({
      data: {
        ...this.state.data,
        ...data.vehicle,
        carType: this.state.data.carType
      }
    })

    if(data.client){
      fetchClient(data.client, (client, created) => {
        if(created){
          toast.success(<span>{this.props.t('decoded_data_client_created')}: <ClientLabel className="text-white" target={'_blank'} client={client} /></span>)
        }

        this.setState(state => ({
          data: {
            ...state.data,
            currentOwner: client
          }
        }))
      })
    }
  }

  render() {
    const {data, saving, errors} = this.state;
    const {submitButton} = this.props;
    const engineOptions = vehicleEngineType.map(value => {
      return {
        label: this.props.t(`vehicle_engine:${value}`),
        value: value,
      }
    });

    return <div>
      <Form onSubmit={e => e.preventDefault()}>
        <Row>
          <Col xs={12} md={6}>
            <div className="d-flex mb-2">
              <InputAztec
                onDecoded={this.handleDecodedData}
              />
            </div>
            <div className="d-flex flex-row flex-nowrap align-items-center mb-2">
              {getWorkshopSetting('vehicle.carTypes').length > 1 && <div className="d-flex flex-row flex-nowrap flex-grow-1 align-items-center mr-1" style={{minWidth: '160px'}}>
                <CarTypeSelect
                  value={data?.carType?.id}
                  onChange={carType => this.onChangeData({
                    carType,
                    damagePatternImageType: first(vehicleDamagesTypesByCarType(carType?.id)),
                  })}
                />
              </div>}
              <div className="mr-1">
                <VehicleDamagePatternImageTypeChoose
                  btnText={<Icon className="fas fa-image" />}
                  carType={data?.carType?.id}
                  selected={data.damagePatternImageType}
                  onChoose={damagePatternImageType => this.onChangeData({ damagePatternImageType })}
                />
              </div>
              <div className="flex-grow-1 mr-1">
                <InputAutocomplete
                  apiListFn={data?.carType && apiPlatform.carMakes.list}
                  apiListParams={{
                    carType: data?.carType?.id
                  }}
                  placeholder={this.props.t('field.car_type')}
                  value={data.brand}
                  onChange={({value, selection}) => {
                    this.onChangeBrandData$.next({
                      brand: value,
                      carMake: selection,
                    });
                  }}
                />
                <FormFeedback>{errors.brand?.errors?.join('; ')}</FormFeedback>
              </div>
              <div className="flex-grow-1 mx-1">
                <InputAutocomplete
                  apiListFn={data?.carMake?.id && apiPlatform.carModels.list}
                  apiListParams={{
                    carMake: data?.carMake?.id
                  }}
                  placeholder={this.props.t('field.car_make')}
                  value={data.model}
                  selection={data?.carMake}
                  onChange={data => {
                    this.onChangeModelData$.next({
                      model: data.value,
                      carModel: data.selection,
                    });
                  }}
                />
                <FormFeedback>{errors.model?.errors?.join('; ')}</FormFeedback>
              </div>
              <div className="flex-grow-1 ml-1">
                <Input invalid={!!errors.color?.errors} placeholder={this.props.t('field.color')} onChange={e => this.onChangeData({ color: e.target.value })} value={data.color} />
                <FormFeedback>{errors.color?.errors?.join('; ')}</FormFeedback>
              </div>
            </div>
            <div className="d-flex flex-row flex-nowrap mb-2">
              <div className="w-50 mr-1">
                <VehicleRegistrationNumberInput
                  invalid={!!errors.registrationNumber?.errors}
                  registrationNumber={data.registrationNumber}
                  errors={errors.registrationNumber?.errors}
                  onChange={registrationNumber => this.onChangeData({ registrationNumber })}
                  onFetchVehicleData={data => {
                    toast.success(this.props.t('vehicle_data_fetched'))
                    this.onChangeData(data)
                  }}
                />
                {errors.registrationNumber?.errors?.length > 0 && <React.Fragment>
                  {this.props.data?.id && <MergeVehicles
                    vehicleId={this.props.data?.id}
                    registrationNumberToMerge={data.registrationNumber}
                    onMerged={vehicle => {
                      this.setState({
                        errors: {},
                        data: this.getOmittedData(vehicle)
                      });
                    }}
                  />}
                </React.Fragment>}
              </div>
              <div className="w-50 ml-1">
                <InputMask
                  className={classnames({
                    'form-control': true,
                    'is-invalid': !!errors?.productionDate?.errors,
                  })}
                  placeholder={this.props.t('field.production_date')}
                  autocomplete="off"
                  mask="9999"
                  maskPlaceholder="rrrr"
                  onChange={e => this.onChangeData({ productionDate: e.target.value.replace(/[^0-9]+/g, '') })}
                  value={data.productionDate?.toString()}
                />
                <FormFeedback>{errors?.productionDate?.errors?.join('; ')}</FormFeedback>
              </div>
            </div>

            <div className="d-flex flex-wrap justify-content-between flex-two-cols">
              {workshopSettingsIsEnabled('vehicle.keyNumber') && <div>
                <Input placeholder={this.props.t('field.key_number')} onChange={e => this.onChangeData({ keyNumber: e.target.value })} value={data.keyNumber} />
                <FormFeedback>{errors.keyNumber?.errors?.join('; ')}</FormFeedback>
              </div>}
              {this.props.workshop.settings.vehicle.technicalInspectionEnd && <div>
                <div id={'v-technicalInspectionEnd-tooltip'}>
                  <AppDatePicker
                    inputClass={classnames({
                      'bg-danger': data.technicalInspectionEnd && (moment.duration(moment(data.technicalInspectionEnd).diff(moment()))).asDays() < this.props.workshop.vehicleTechnicalInspectionEnd
                    })}
                    isClearable
                    placeholder={this.props.t('field.technical_inspection_end')}
                    value={data.technicalInspectionEnd}
                    onChange={technicalInspectionEnd => this.onChangeData({ technicalInspectionEnd })}
                    errors={errors?.technicalInspectionEnd?.errors}
                  />
                </div>
                <Tooltip id={'v-technicalInspectionEnd-tooltip'} msg={
                  data.technicalInspectionEnd && (moment.duration(moment(data.technicalInspectionEnd).diff(moment()))).asDays() < this.props.workshop.vehicleTechnicalInspectionEnd
                    ? this.props.t('field.technical_inspection_end')
                    : this.props.t('field.technical_inspection_end')
                }/>
              </div>}
              {this.props.workshop.settings.vehicle.insuranceEnd && <div>
                <div id={'v-insuranceEnd-tooltip'}>
                  <AppDatePicker
                    inputClass={classnames({
                      'bg-danger': data.insuranceEnd && (moment.duration(moment(data.insuranceEnd).diff(moment()))).asDays() < this.props.workshop.vehicleInsuranceEnd
                    })}
                    isClearable
                    placeholder={this.props.t('field.insurance_end')}
                    value={data.insuranceEnd}
                    onChange={insuranceEnd => this.onChangeData({ insuranceEnd })}
                    errors={errors?.insuranceEnd?.errors}
                  />
                </div>

                <Tooltip id={'v-insuranceEnd-tooltip'} msg={
                  data.insuranceEnd && (moment.duration(moment(data.insuranceEnd).diff(moment()))).asDays() < this.props.workshop.vehicleInsuranceEnd
                    ? this.props.t('insurance_end_close_tooltip')
                    : this.props.t('field.insurance_end')
                }/>
              </div>}
              {workshopSettingsIsEnabled('vehicle.tachographEnd') && <div>
                <div id={'v-tachographEnd-tooltip'}>
                  <AppDatePicker
                    inputClass={classnames({
                      'bg-danger': data.tachographEnd && (moment.duration(moment(data.tachographEnd).diff(moment()))).asDays() < this.props.workshop.vehicleTachographEnd
                    })}
                    isClearable
                    placeholder={this.props.t('field.tachograph_end')}
                    value={data.tachographEnd}
                    onChange={tachographEnd => this.onChangeData({ tachographEnd })}
                    errors={errors?.tachographEnd?.errors}
                  />
                </div>

                <Tooltip id={'v-tachographEnd-tooltip'} msg={
                  data.tachographEnd && (moment.duration(moment(data.tachographEnd).diff(moment()))).asDays() < this.props.workshop.vehicleTachographEnd
                    ? this.props.t('field.tachograph_end_close_tooltip')
                    : this.props.t('field.tachograph_end')
                }/>
              </div>}
              <div className="d-flex flex-row flex-nowrap">
                <ClientSelect
                  className="w-100"
                  placeholder={this.props.t('field.current_owner')}
                  onChange={client => {
                    this.onChangeData({ currentOwner: client })
                  }}
                  client={data?.currentOwner?.id} />
                <FormFeedback>{errors.vehicle?.errors?.join('; ')}</FormFeedback>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6}>
            <div className="d-flex flex-wrap justify-content-between flex-two-cols">
              <div>
                <AppDatePicker
                  isClearable
                  placeholder={this.props.t('field.first_registration')}
                  value={data.firstRegistration}
                  onChange={firstRegistration => this.onChangeData({ firstRegistration })}
                  errors={errors?.firstRegistration?.errors}
                />
              </div>
              <div>
                <Select
                  classNamePrefix="react-select"
                  placeholder={this.props.t('field.engine')}
                  value={data.engine ? engineOptions.find(e => e.value === data.engine) : false}
                  options={engineOptions}
                  onChange={option => this.onChangeData({ engine: option.value })}
                />
              </div>
              <div>
                <VehicleVinInput
                  onChange={vin => this.onChangeData({ vin })}
                  invalid={!!errors.vin?.errors}
                  vin={data.vin}
                  errors={errors.vin?.errors}
                  onFetchVehicleData={data => {
                    toast.success(this.props.t('vehicle_data_fetched'))
                    this.onChangeData(data)
                  }}
                />
                {errors.vin?.errors?.length > 0 && <React.Fragment>
                  {this.props.data?.id && <MergeVehicles
                    vehicleId={this.props.data?.id}
                    vinToMerge={data.vin}
                    onMerged={vehicle => {
                      this.setState({
                        errors: {},
                        data: this.getOmittedData(vehicle)
                      });
                    }}
                  />}
                </React.Fragment>}
              </div>
              <div>
                <Input invalid={!!errors.engineCode?.errors} placeholder={this.props.t('field.engine_code')} onChange={e => this.onChangeData({ engineCode: e.target.value.replace(/[^0-9a-zA-Z\s/\-_]+/g, '').toUpperCase() })} value={data.engineCode} />
                <FormFeedback>{errors.engineCode?.errors?.join('; ')}</FormFeedback>
              </div>
              {workshopSettingsIsEnabled('vehicle.axleSerialNumber') && <div>
                <Input invalid={!!errors.axleSerialNumber?.errors} placeholder={this.props.t('field.axle_serial_number')} onChange={e => this.onChangeData({ axleSerialNumber: e.target.value })} value={data.axleSerialNumber} />
                <FormFeedback>{errors.axleSerialNumber?.errors?.join('; ')}</FormFeedback>
              </div>}
              {workshopSettingsIsEnabled('vehicle.hsnTsnCodes') && <React.Fragment>
                <div>
                  <Input invalid={!!errors.hsnCode?.errors} placeholder="HSN" onChange={e => this.onChangeData({ hsnCode: e.target.value.replace(/[^0-9a-zA-Z]+/g, '').toUpperCase().substring(0, 4) })} value={data.hsnCode} />
                  <FormFeedback>{errors.hsnCode?.errors?.join('; ')}</FormFeedback>
                </div>
                <div>
                  <Input invalid={!!errors.tsnCode?.errors} placeholder="TSN" onChange={e => this.onChangeData({ tsnCode: e.target.value.replace(/[^0-9a-zA-Z]+/g, '').toUpperCase().substring(0, 3) })} value={data.tsnCode} />
                  <FormFeedback>{errors.tsnCode?.errors?.join('; ')}</FormFeedback>
                </div>
              </React.Fragment>}
              <div>
                <InputGroup>
                  <InputMask
                    className={classnames({
                      'form-control': true,
                      'is-invalid': !!errors?.capacity?.errors,
                    })}
                    placeholder={this.props.t('field.capacity')}
                    mask=""
                    maskPlaceholder=""
                    onChange={e => this.onChangeData({ capacity: e.target.value.replace(/[^0-9a-zA-Z\s.,]+/g, '') })}
                    value={data.capacity?.toString()}
                  />
                  <InputGroupAddon addonType="append"><InputGroupText>cm<sup>3</sup></InputGroupText></InputGroupAddon>
                </InputGroup>
                <FormFeedback>{errors.capacity?.errors?.join('; ')}</FormFeedback>
              </div>
              <div>
                <InputGroup>
                  <InputMask
                    className={classnames({
                      'form-control': true,
                      'is-invalid': !!errors?.enginePower?.errors,
                    })}
                    placeholder={this.props.t('field.engine_power')}
                    maskPlaceholder=""
                    onChange={e => this.onChangeData({ enginePower: e.target.value.replace(/[^0-9a-zA-Z\s.,]+/g, '') })}
                    value={data.enginePower?.toString()}
                  />
                  <InputGroupAddon addonType="append" style={{width: '66px'}}>
                    <SelectVehicleEnginePowerUnit
                      value={data.enginePowerUnit}
                      onChange={enginePowerUnit => this.onChangeData({ enginePowerUnit })}
                    />
                  </InputGroupAddon>
                </InputGroup>
              </div>
              <div>
                <SelectMileageUnit value={data.mileageUnit} onChange={mileageUnit => this.onChangeData({ mileageUnit })}/>
                <FormFeedback>{errors.mileageUnit?.errors?.join('; ')}</FormFeedback>
              </div>
              {workshopSettingsIsEnabled('vehicle.paintCode') && <div>
                <Input invalid={!!errors.paintCode?.errors} placeholder={this.props.t('field.paint_code')} onChange={e => this.onChangeData({ paintCode: e.target.value })} value={data.paintCode} />
                <FormFeedback>{errors.paintCode?.errors?.join('; ')}</FormFeedback>
              </div>}
            </div>
            <div className="w-100">
              <Input type={'textarea'} rows={4} placeholder={this.props.t('field.description')} onChange={e => this.onChangeData({ description: e.target.value })} value={data.description} />
              <FormFeedback>{errors.description?.errors?.join('; ')}</FormFeedback>
            </div>
          </Col>
        </Row>
      </Form>
      <div className="ml-auto">
        {submitButton && <Row className="mt-3">
          <Col className="d-flex justify-content-end">
            <AppFormCancelButton />
            <Button
              className="ml-3"
              loading={saving}
              onClick={this.onSubmit}
            >
              <i className="fas fa-save" />
              <span>{this.props.t('common:btn.save')}</span>
            </Button>
          </Col>
        </Row>}
      </div>
    </div>
  }
}

VehicleForm.defaultProps = {
  dataInitial: {},
  data: {
    id: null,
    vin: '',
    engineCode: '',
    hsnCode: null,
    tsnCode: null,
    brand: '',
    carMake: null,
    carType: null,
    damagePatternImageType: null,
    model: '',
    carModel: null,
    registrationNumber: '',
    color: '',
    firstRegistration: null,
    productionDate: null,
    technicalInspectionEnd: null,
    insuranceEnd: null,
    tachographEnd: null,
    capacity: '',
    engine: '',
    enginePower: '',
    enginePowerUnit: 'kW',
    description: '',
    keyNumber: null,
  },
  submitButton: true,
};

VehicleForm.propTypes = {
  dataInitial: PropTypes.object,
  data: PropTypes.shape({
    id: PropTypes.number,
    vin: PropTypes.string,
    engineCode: PropTypes.string,
    hsnCode: PropTypes.string,
    tsnCode: PropTypes.string,
    brand: PropTypes.string,
    carType: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
    carMake: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
    model: PropTypes.string,
    carModel: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
    registrationNumber: PropTypes.string,
    color: PropTypes.string,
    firstRegistration: PropTypes.string,
    productionDate: PropTypes.string,
    technicalInspectionEnd: PropTypes.string,
    insuranceEnd: PropTypes.string,
    tachographEnd: PropTypes.string,
    capacity: PropTypes.string,
    engine: PropTypes.string,
    enginePower: PropTypes.string,
    enginePowerUnit: PropTypes.string,
    description: PropTypes.string,
    keyNumber: PropTypes.string,
  }),
  submitButton: PropTypes.bool.isRequired,
  onCreated: PropTypes.func.isRequired,
  onSavingStart: PropTypes.func,
  onSavingStop: PropTypes.func,
  workshop: PropTypes.shape({
    vehicleTechnicalInspectionEnd: PropTypes.number.isRequired,
    vehicleInsuranceEnd: PropTypes.number.isRequired,
    vehicleTachographEnd: PropTypes.number.isRequired,
    settings: PropTypes.shape({
      vehicle: PropTypes.shape({
        technicalInspectionEnd: PropTypes.bool.isRequired,
        insuranceEnd: PropTypes.bool.isRequired,
        tachographEnd: PropTypes.bool.isRequired,
        hsnTsnCodes: PropTypes.bool.isRequired,
      }).isRequired,
    }).isRequired,
  }).isRequired,
};

function mapStateToProps(state) {
  return {
    workshop: state.workshop,
  }
}

export default connect(mapStateToProps, null, null, {forwardRef: true})(withTranslation('vehicle', {withRef: true})(VehicleForm));
